export default __webpack_public_path__ + "static/media/about.3aae4165.jpg";